import { render, staticRenderFns } from "./Stock_Insumos.vue?vue&type=template&id=12ba28b2&scoped=true&"
import script from "./Stock_Insumos.vue?vue&type=script&lang=js&"
export * from "./Stock_Insumos.vue?vue&type=script&lang=js&"
import style0 from "./Stock_Insumos.vue?vue&type=style&index=0&id=12ba28b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ba28b2",
  null
  
)

export default component.exports